// extracted by mini-css-extract-plugin
export var createdDate = "_hl-1";
export var divider = "_hl-2";
export var headerDivider = "_hl-3";
export var messagesCard = "_hl-0";
export var messagesContainer = "_hl-6";
export var messagesContainerWrapper = "_hl-4";
export var showLeftPanelButton = "_hl-8";
export var topButtons = "_hl-7";
export var withPadding = "_hl-5";